import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";
import { useAuth } from "../../Context/AuthContext";
import "../../Public/css/fonts.css";

export default function MainDashboard() {
  const navigate = useNavigate();
  const { designation } = useAuth();

  const DashboardFunc = () => {
    if (designation == "Owner" || designation == "Partner") {
      navigate("/dashboard");
    } else if (designation == "Manager") {
      navigate("/dashboard");
    } else if (designation == "Tenant") {
      navigate("/tenantdashboard");
    } else {
      navigate("/tenantlist");
    }
  };

  return (
    <>
      <DashboardLayouts>
        <ToastContainer />
        {DashboardFunc()}
      </DashboardLayouts>
    </>
  );
}
